module.exports = __webpack_public_path__ + "56195c550358204793d05805f9315a47.jpg";